import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054c19b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-[508px] mt-[12px] w-full",
  "data-testid": 'build-groups-table'
}
const _hoisted_2 = ["data-cy-management-build-group-name"]
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" All agents in this build group will be reassigned to the ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Default", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" build group ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-[282px] gordita-400-11",
  "data-testid": "management-build-group--floating-delete-tooltip"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Cannot delete a build group when agents in the group are currently initiating a build")
], -1))
const _hoisted_8 = {
  class: "row flex items-center",
  "data-testid": "management-build-group--cloud-agents-header"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gordita-400-11 w-[288px]" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Determines if Cloud Agents can assist in builds initiated from agents in this build group")
], -1))
const _hoisted_10 = ["data-cy-management-build-group-name"]
const _hoisted_11 = { class: "edit-input truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uis uis-padlock text-Text/text_medium text-[16px] mr-[8px]" }, null, -1))
const _hoisted_14 = ["data-cy-management-build-group-name"]
const _hoisted_15 = { class: "edit-input truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_16 = ["data-cy-management-build-group-name"]
const _hoisted_17 = { class: "truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_18 = {
  key: 1,
  class: "row flex items-center gap-[8px]",
  "data-testid": "management-build-group--cloud-agents-legend"
}
const _hoisted_19 = { class: "text-Text/text_high gordita-400-12" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediToggle, IncrediTable, IncrediLegend, IncrediTooltip } from 'incredi-ui';
import COLORS from '@/design-system/colors.json';
import { computed, ref, watch } from 'vue';
import 'moment-timer';
import { CLOUD_STATUS } from '@/views/settings/settingsCloud/cloud.const';
import FloatingDeleteCell from '@/views/settings/components/tableCells/floatingDeleteCell.vue';
import DeleteInfoCell from '@/views/agents/components/manage-dialog/deleteInfoCell.vue';
import { useBuildGroups } from '@/views/agents/components/buildGroups/buildGroups.helpers';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useNotify } from '@/services/notify/notify';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import InputField from '@/views/agents/components/manage-dialog/inputField.vue';
import { WINDOWS_HEADERS, WINDOWS_HEADERS_WITHOUT_CLOUD, LINUX_HEADERS } from '@/views/agents/components/buildGroups/CONST';
import EmptySearchPlaceholder from '@/components/common/empty-table-placeholder.vue';
import { useOsService } from '@/services/OsService/OsService';
import { SYSTEM_BUILD_GROUPS } from '@/views/agents/agents.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'buildGroupsTable',
  props: {
    buildGroups: null,
    isClosed: { type: Boolean }
  },
  emits: ["updateTableSort", "keep-show-error"],
  setup(__props: any, { emit }: { emit: ({ (e: 'updateTableSort', value: { name: string; descending: boolean }): void; (e: 'keep-show-error', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buildGroups: any;
  isClosed: boolean;
}

const loadingState = {
  delete: new Set<string>(),
};
const rowHeight = 48;
const disabledDeleteIndex = ref<null | number>(null);
const hoveredRow = ref<number | undefined>(undefined);
const activeRowIndex = ref<number | undefined>(undefined); // For lock delete data
const showDeleteData = ref(false);
const errorInputIndex = ref(-1);
const cloudAgentsTooltip = ref(false);
const deleteButtonPressed = ref(false);
const { toastMessage } = useNotify();

const itemRefs = ref([] as any);

const setItemRef = (el: any, index: number) => {
  if (el) {
    itemRefs.value[index] = el;
  }
};

const { searchInputVal, deleteBuildGroup, editBuildGroup, addNewBuildGroup, isBuildGroupExists, sort, coordinatorId, clearNewBuildGroupRow } = useBuildGroups();
const commonDataQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorId || '' }));
const cloudStatus = computed(() => commonDataQuery?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus || false);
const osService = useOsService();
const getTableColumns = computed(() => {
  if (osService?.isWindows.value) {
    if (cloudStatus.value === CLOUD_STATUS.Enabled) {
      return WINDOWS_HEADERS;
    }
    return WINDOWS_HEADERS_WITHOUT_CLOUD;
  }
  if (osService?.isUnix.value) {
    return LINUX_HEADERS;
  }
  return WINDOWS_HEADERS;
});

const buildGroupList = computed(() => props.buildGroups || []);

watch(
  () => buildGroupList.value,
  (newVal, oldVal) => {
    if (newVal.length > oldVal.length) {
      errorInputIndex.value = -1;
    }
  },
);


const handleSortChange = (tableState: any) => {
  sort.value = {
    name: tableState?.sort?.name || 'Name',
    descending: tableState?.sort?.descending || false,
  };
  emit('updateTableSort', sort.value);
};

const handleUpdateBuildGroup = async (bgId: string, newBuildGroup?: string | undefined, cloudEnabled?: boolean | undefined) => {
  try {
    await editBuildGroup(bgId, newBuildGroup, cloudEnabled);
    if (props.isClosed) toastMessage('Changes saved', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage('Operation Failed, please try again', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

const handleDeleteBuildGroup = async (buildGroupId: string | null | undefined) => {
  if (!buildGroupId) {
    deleteButtonPressed.value = false;
    return;
  }
  try {
    if (loadingState.delete.has(buildGroupId)) {
      deleteButtonPressed.value = false;
      return;
    }
    loadingState.delete.add(buildGroupId);
    await deleteBuildGroup(buildGroupId);
    loadingState.delete.delete(buildGroupId);
    deleteButtonPressed.value = false;
  } catch (error) {
    loadingState.delete.delete(buildGroupId);
    deleteButtonPressed.value = false;
    toastMessage('Operation Failed, please try again', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

const handleAddNewBuildGroup = async (newBuildGroup: string) => {
  try {
    await addNewBuildGroup(newBuildGroup);
    if (props.isClosed) toastMessage(' New build group added', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage('Operation Failed, please try again', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

const setCloudEnabled = (index: number) => {
  handleUpdateBuildGroup(buildGroupList?.value[index]?.id || '', undefined, !buildGroupList?.value[index]?.cloudEnabled);
};

const handleHoverRow = (index: number | undefined) => {
  hoveredRow.value = index;
};

const resetBuildGroupsTableValues = (index?: number) => {
  if (index !== undefined) {
    itemRefs.value?.[index].reset();
  }
  deleteButtonPressed.value = false;
  activeRowIndex.value = undefined;
  showDeleteData.value = false;
};

const hoveredRowIndex = computed(() => {
  if (activeRowIndex.value !== undefined) {
    return activeRowIndex.value;
  }
  return hoveredRow.value;
});

const isSystemGroup = ({ id, name }: { id: string; name: string }): boolean => {
  if (osService?.isWindows.value) {
    return (Object.values(SYSTEM_BUILD_GROUPS) as string[]).includes(id);
  }
  return name === 'Default';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_unref(IncrediTable), {
          key: __props.buildGroups.length,
          "model-value": {
          sort: _unref(sort),
        },
          "sort-name": _unref(sort).name,
          "sort-descending": _unref(sort).descending,
          "row-height": rowHeight,
          "header-tooltip": true,
          columns: _unref(getTableColumns) as any,
          items: __props.buildGroups as any || [],
          resizable: false,
          class: _normalizeClass(["incredi-table shadow-none flex-grow w-full h-full", { 'pointer-events-none': activeRowIndex.value !== undefined || showDeleteData.value }]),
          "hovered-row-prop": _unref(hoveredRowIndex),
          "expand-row-info": { expandRowIndex: errorInputIndex.value, height: 72 },
          onHoveredRow: handleHoverRow,
          "onUpdate:modelValue": handleSortChange
        }, {
          "floating-row": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["row-test-floating", { 'pointer-events-auto': activeRowIndex.value === index }]),
              "data-testid": "management-build-group--floating-delete-row",
              "data-cy-management-build-group-name": _unref(buildGroupList)[index]?.name
            }, [
              _createVNode(_unref(IncrediTooltip), {
                hover: "",
                direction: "bottom-sticky-right",
                "offset-x": 25,
                "offset-y": -4,
                delay: 200,
                "model-value": disabledDeleteIndex.value === index,
                "onUpdate:modelValue": 
                tooltip => {
                  disabledDeleteIndex.value = _unref(buildGroupList)[index]?.hasRunningBuild && tooltip ? index : null;
                }
              
              }, {
                content: _withCtx(() => [
                  _createVNode(IbxScopedCss, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onMousedown: 
                  () => {
                    deleteButtonPressed.value = true;
                    if (errorInputIndex.value !== -1 && errorInputIndex.value !== index) {
                      itemRefs.value[errorInputIndex.value].reset();
                      errorInputIndex.value = -1;
                    }
                    errorInputIndex.value = -1;
                    if (_unref(buildGroupList)[index]?.agentCount === 0 || _unref(buildGroupList)[index]?.agentCount === null) {
                      if (_unref(buildGroupList)[index].id) {
                        handleDeleteBuildGroup(_unref(buildGroupList)[index]?.id);
                      } else {
                        _unref(clearNewBuildGroupRow)();
                        deleteButtonPressed.value = false;
                      }
                    } else if (!_unref(buildGroupList)[index]?.hasRunningBuild) {
                      // if there are agents that are participating in running build, we don't want to enable to delete BG
                      showDeleteData.value = true;
                      activeRowIndex.value = index;
                    }
                  }
                
                  }, [
                    ((index === hoveredRow.value || index === activeRowIndex.value) && !isSystemGroup(_unref(buildGroupList)[index]) && !showDeleteData.value)
                      ? (_openBlock(), _createBlock(FloatingDeleteCell, {
                          key: 0,
                          class: _normalizeClass({ 'delete-btn-disabled': _unref(buildGroupList)[index]?.hasRunningBuild })
                        }, null, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_3),
                  (index === activeRowIndex.value && showDeleteData.value)
                    ? (_openBlock(), _createBlock(DeleteInfoCell, {
                        key: 0,
                        onClickOutside: resetBuildGroupsTableValues,
                        onDeleteRow: 
                  () => {
                    resetBuildGroupsTableValues();
                    handleDeleteBuildGroup(_unref(buildGroupList)[index]?.id);
                  }
                ,
                        onCancelDelete: ($event: any) => (resetBuildGroupsTableValues(index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _hoisted_5,
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onDeleteRow", "onCancelDelete"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["model-value", "onUpdate:modelValue"])
            ], 10, _hoisted_2)
          ]),
          "header-CloudAgents": _withCtx(({ column }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(column.name), 1),
              _createVNode(_unref(IncrediTooltip), {
                modelValue: cloudAgentsTooltip.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cloudAgentsTooltip).value = $event)),
                class: "cloud-agents-tooltip",
                "data-testid": "management-build-group--cloud-agents-tooltip",
                hover: "",
                direction: "bottom-sticky-right",
                delay: 200
              }, {
                content: _withCtx(() => [
                  _createVNode(IbxScopedCss, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["text-[16px] ml-[4px] text-Text/text_low", cloudAgentsTooltip.value ? 'uis uis-question-circle' : 'uil uil-question-circle'])
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          "content-Name": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              "data-cy-management-build-group-name": _unref(buildGroupList)[index]?.name,
              "data-testid": "management-build-group--name-cell",
              class: _normalizeClass(["incredi-table-row build-group-name-row", { '!px-[0px] py-[6px]': !isSystemGroup(_unref(buildGroupList)[index]), 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                (isSystemGroup(_unref(buildGroupList)[index]))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(_unref(buildGroupList)[index]?.name), 1)
                    ]))
                  : (_openBlock(), _createBlock(InputField, {
                      key: 1,
                      ref: el => setItemRef(el, index),
                      "is-active": index === activeRowIndex.value,
                      "data-cy-management-build-group-name": _unref(buildGroupList)[index]?.name,
                      "data-testid": "management-build-group--name-input-field",
                      class: _normalizeClass({ 'build-group-name-input': _unref(cloudStatus) !== _unref(CLOUD_STATUS).Enabled }),
                      "input-text": _unref(buildGroupList)[index]?.name || '',
                      "min-input-length": 1,
                      "is-hovered": index === hoveredRow.value,
                      "is-valid": true,
                      ghost: index !== hoveredRow.value,
                      error: errorInputIndex.value === index,
                      "error-message": "Build group already exists",
                      onFocusWithin: 
                  () => {
                    if (errorInputIndex.value !== -1 && errorInputIndex.value !== index) {
                      itemRefs.value[errorInputIndex.value].reset();
                      errorInputIndex.value = -1;
                      _unref(clearNewBuildGroupRow)();
                    }
                    activeRowIndex.value = index;
                  }
                ,
                      onBlurWithin: _cache[1] || (_cache[1] = 
                  () => {
                    if (!deleteButtonPressed.value) {
                      activeRowIndex.value = undefined;
                    }
                  }
                ),
                      "onClear:input": _cache[2] || (_cache[2] = 
                  () => {
                    errorInputIndex.value = -1;
                    _unref(clearNewBuildGroupRow)();
                  }
                ),
                      "onUpdate:input": (val) => {
                  if (deleteButtonPressed.value) {
                    itemRefs.value[index].reset();
                    return;
                  }
                   errorInputIndex.value = -1
                 if(_unref(isBuildGroupExists)(val)){
                     errorInputIndex.value = index
                     emit('keep-show-error',true)
                 }
                  else {
                    if(_unref(buildGroupList)[index]?.name === ''){
                      handleAddNewBuildGroup(val)
                      _unref(clearNewBuildGroupRow)()
                  }
                    else handleUpdateBuildGroup(_unref(buildGroupList)[index]?.id || '', val)
                  }
                }
                    }, null, 8, ["is-active", "data-cy-management-build-group-name", "class", "input-text", "is-hovered", "ghost", "error", "onFocusWithin", "onUpdate:input"]))
              ])
            ], 10, _hoisted_10)
          ]),
          "content-AssignedAgents": _withCtx(({ index }) => [
            _createElementVNode("div", {
              "data-cy-management-build-group-name": _unref(buildGroupList)[index]?.name,
              "data-testid": "management-build-group--assigned-agent-row",
              class: _normalizeClass(["incredi-table-row build-group-assigned-agent-row", { 'h-fit': errorInputIndex.value, 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(buildGroupList)[index]?.agentCount || 0), 1)
            ], 10, _hoisted_14)
          ]),
          "content-CloudAgents": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              "data-cy-management-build-group-name": _unref(buildGroupList)[index]?.name,
              class: _normalizeClass(["incredi-table-row build-group-cloud-agent-row", { 'h-fit': errorInputIndex.value, 'p-[14px]': index === hoveredRow.value || index === activeRowIndex.value, 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", _hoisted_17, [
                ((index === hoveredRow.value || index === activeRowIndex.value) && !isSystemGroup(_unref(buildGroupList)[index]))
                  ? (_openBlock(), _createBlock(_unref(IncrediToggle), {
                      key: 0,
                      "model-value": !!_unref(buildGroupList)[index]?.cloudEnabled,
                      disabled: isSystemGroup(_unref(buildGroupList)[index]),
                      "data-testid": "management-build-group--cloud-agents-toggle",
                      onClick: _withModifiers(() => setCloudEnabled(index), ["stop","prevent"])
                    }, null, 8, ["model-value", "disabled", "onClick"]))
                  : (_unref(osService)?.isWindows.value && _unref(buildGroupList)[index]?.id !== _unref(SYSTEM_BUILD_GROUPS).Universal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_unref(IncrediLegend), {
                          color: _unref(buildGroupList)[index]?.cloudEnabled ? _unref(COLORS)['System/app_primary'] : `${_unref(COLORS)['System/app_disabled']}40`,
                          size: 8,
                          class: "min-w-[8px]"
                        }, null, 8, ["color"]),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(buildGroupList)[index]?.cloudEnabled ? 'Enabled' : 'Disabled'), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_16)
          ]),
          "no-data": _withCtx(() => [
            _createVNode(EmptySearchPlaceholder, {
              "data-testid": 'build-groups-empty-search-placeholder',
              "has-filters-applied": "",
              "search-items-name": "Build Groups",
              class: "w-full h-full",
              onClearFilters: _cache[3] || (_cache[3] = () => (searchInputVal.value = ''))
            })
          ]),
          _: 1
        }, 8, ["model-value", "sort-name", "sort-descending", "columns", "items", "hovered-row-prop", "class", "expand-row-info"]))
      ])
    ]),
    _: 1
  }))
}
}

})